module.exports = __webpack_public_path__ + "static/media/envelope-line.3b799600.svg";